import { render } from "./PersecutorTemplate.vue?vue&type=template&id=53d91d48&scoped=true"
import script from "./PersecutorTemplate.vue?vue&type=script&lang=js"
export * from "./PersecutorTemplate.vue?vue&type=script&lang=js"

import "./PersecutorTemplate.vue?vue&type=style&index=0&id=53d91d48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d91d48"]])

export default __exports__